import React from 'react';

const CTASection = ({ onGetQuoteClick }) => {
  return (
    <section id="contact" className="relative py-24 sm:py-32 bg-white overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.googleapis.com/uxpilot-auth.appspot.com/8b06285336-54e609ea6a801a349774.png"
          alt="Modern luxury building architecture, glass and steel structure, contemporary design, professional photography"
          className="w-full h-full object-cover opacity-10"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-white/90"></div>
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-block mb-6">
          <div className="flex items-center space-x-3 bg-premium-gold/10 backdrop-blur-sm px-6 py-3 border border-premium-gold/30">
            <i className="fa-solid fa-phone text-premium-gold"></i>
            <span className="text-premium-dark text-sm tracking-wider font-semibold">START YOUR PROJECT TODAY</span>
          </div>
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-premium-dark mb-6 leading-tight">
          Ready to Elevate<br />Your Building?
        </h2>
        <p className="text-lg sm:text-xl lg:text-2xl text-gray-600 mb-8 sm:mb-12 leading-relaxed max-w-3xl mx-auto">
          Schedule a consultation with our engineering team to discuss your vertical mobility needs. We'll design a custom solution that exceeds your expectations.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-8 sm:mb-12">
          <button 
            onClick={() => onGetQuoteClick && onGetQuoteClick()}
            className="w-full sm:w-auto bg-premium-gold text-premium-dark px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold hover:bg-premium-dark hover:text-white transition-colors flex items-center justify-center space-x-3"
          >
            <span>Get Free Consultation</span>
            <i className="fa-solid fa-arrow-right"></i>
          </button>
          <a href="/stairlifte_brochure.pdf" download className="w-full sm:w-auto border-2 border-premium-dark text-premium-dark px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold hover:bg-premium-dark hover:text-white transition-colors">
            Download Brochure
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 pt-8 sm:pt-12 border-t border-gray-300 max-w-4xl mx-auto">
          <div>
            <i className="fa-solid fa-phone text-premium-gold text-2xl sm:text-3xl mb-4"></i>
            <div className="text-premium-dark font-semibold mb-2">Call Us</div>
            <div className="text-gray-600">0403708601</div>
          </div>
          <div>
            <i className="fa-solid fa-envelope text-premium-gold text-2xl sm:text-3xl mb-4"></i>
            <div className="text-premium-dark font-semibold mb-2">Email Us</div>
            <div className="text-gray-600">
              <a href='mailto:info@stairlifte.com.au'>info@stairlifte.com.au</a></div>
          </div>
          <div>
            <i className="fa-solid fa-location-dot text-premium-gold text-2xl sm:text-3xl mb-4"></i>
            <div className="text-premium-dark font-semibold mb-2">Visit Us</div>
            <div className="text-gray-600">D5/16 Elonera street, Noble Park North</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
